import React from "react";
import DashboardBarChart from "../../common/DashboardBarChart";
import NoData from "../../common/NoData";

const VisitMetricsWidget = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-1/4 mb-4"></div>
        <div className="h-48 bg-gray-100 rounded"></div>
      </div>
    );
  }

  if (!data || !data.recentActivity) {
    return (
      <div className="bg-white rounded-lg shadow ">
        <h3 className="text-lg font-semibold text-gray-800 mb-1 text-balance">
          Visit Metrics
        </h3>
        <NoData />
      </div>
    );
  }
  const activityData = [
    { period: "7 Days", visits: data.recentActivity.last7Days || 0 },
    { period: "30 Days", visits: data.recentActivity.last30Days || 0 },
    { period: "90 Days", visits: data.recentActivity.last90Days || 0 },
  ];
  return (
    <div className="bg-white">
      {/* <h3 className="text-lg font-semibold text-gray-800 mb-4 text-balance">
        Visit Metrics
      </h3> */}
      <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
        Visit Metrics
      </h3>

      <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
        <div>
          <div className="h-96">
            {" "}
            <DashboardBarChart
              items={activityData.map((item) => ({ name: item.period, count: item.visits }))}
              unit="visits"
            />
          </div>

          {/* Chart Summary - Larger and more prominent */}
          {/* <div className="mt-3 p-4 bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg border border-blue-200">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="text-center">
                <div className="text-sm font-medium text-blue-700 mb-1">
                  Total Visits
                </div>
                <div className="text-3xl font-bold text-blue-800">
                  {totalVisits}
                </div>
              </div>
              <div className="text-center">
                <div className="text-sm font-medium text-blue-700 mb-1">
                  Average Daily
                </div>
                <div className="text-3xl font-bold text-blue-800">
                  {avgDaily}
                </div>
              </div>
              <div className="text-center">
                <div className="text-sm font-medium text-blue-700 mb-1">
                  Period Comparison
                </div>
                <div className="text-3xl font-bold text-blue-800">
                  {activityData[1].visits > activityData[0].visits ? "↑" : "↓"}
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            {activityData.map((item, index) => (
              <div
                key={index}
                className="p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div
                      className="w-3 h-3 rounded-full mr-3"
                      style={{ backgroundColor: "#137E81" }}
                    ></div>
                    <span className="font-medium text-gray-700">
                      {item.period}
                    </span>
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-bold text-gray-800">
                      {item.visits}
                    </div>
                    <div className="text-sm text-gray-500">visits</div>
                  </div>
                </div>
              </div>
            ))}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default VisitMetricsWidget;
